import { z } from 'zod'

// Crop rect as fractions of the (orientation-corrected) source image, so it is
// resolution-independent. The server resolves fractions to pixels and clamps.
export const cropRectSchema = z.object({
  left: z.number().min(0).max(1),
  top: z.number().min(0).max(1),
  width: z.number().min(0).max(1),
  height: z.number().min(0).max(1),
})

export type CropRect = z.infer<typeof cropRectSchema>
